import { Tooltip, TooltipProps } from '@sgme/ui';
import { IntlKey } from 'locales';
import { FC } from 'react';
import { FormattedMessage } from 'react-intl';

import type { FormStatusIconProps } from '../FormStatusIcon/FormStatusIcon';
import { FormStatusIcon } from '../FormStatusIcon/FormStatusIcon';

export type FormStatusIconWithTooltipProps = FormStatusIconProps & {
  tooltipId: string;
  tooltipLocation: TooltipProps['position'];
};

export const FormStatusIconWithTooltip: FC<FormStatusIconWithTooltipProps> = props => {
  const { tooltipId, tooltipLocation, ...iconProps } = props;

  return props.status ? (
    <div id={tooltipId}>
      <Tooltip
        position={tooltipLocation}
        contents={<FormattedMessage id={`form.status.${props.status}` as IntlKey} />}
        data-e2e="tooltip-element"
      >
        <div data-e2e="tooltip-trigger">
          <FormStatusIcon {...iconProps} />
        </div>
      </Tooltip>
    </div>
  ) : (
    <FormStatusIcon {...iconProps} />
  );
};
